const MeasureUnit = {

    // FIELDS
    "name": "الاسم",
    "description": "الوصف",
    "unit_type": "نوع الوحدة",
    "search": "بحث",

    // PAGE HEADER
    "measurement_unit": "وحدة القياس",

    // ERROR
    "error_name": "الرجاء إدخال الاسم",
    "error_desc": "الرجاء إدخال الوصف",
    "error_unitType": "الرجاء اختيار نوع الوحدة",

    // TABLE HEADER
    "table_name": "الاسم",
    "table_description": "الوصف",
    "table_unit_type": "نوع الوحدة",

}

export default MeasureUnit;
